import { clsx } from "clsx";
import React from "react";

interface FilterCountPillProps {
  count: number;
}

const FilterCountPill: React.FC<FilterCountPillProps> = ({ count }) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center rounded-full px-2 h-9 bg-action-secondary-default hover:bg-action-secondary-hover text-white cursor-pointer",
      )}
    >
      <div className="flex flex-row items-center gap-1">+ {count}</div>
    </div>
  );
};

export default FilterCountPill;
